// SUR-2625 — attribution for the two Connect Leaflet maps (the Custom Search
// island and the listing-detail Stimulus map).
//
// Leaflet ships under BSD-2-Clause, whose only condition is that the copyright
// notice is retained — it does NOT have to sit inside the map. We keep that
// notice in docs/third-party-notices.md and drop Leaflet's default attribution
// PREFIX (the Ukrainian flag glyph + the "Leaflet" hyperlink) from the maps
// themselves, via `attributionControl.setPrefix(false)`.
//
// The TILE PROVIDER's credit is a separate, non-optional obligation (OSM's
// license requires a visible, linked credit), so the attribution control itself
// stays enabled and always carries a credit line.

export const DEFAULT_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

// The credit Stadia Maps requires — Stadia + OpenMapTiles + OpenStreetMap, with
// OSM linked to its copyright page as OpenStreetMap's attribution guide asks.
// Mirrors Connect::DEFAULT_MAP_TILE_ATTRIBUTION in app/models/connect.rb (a test
// asserts the two match so they can't drift); the server normally supplies the
// string and this is the client-side fallback for a render path that doesn't
// emit the layout meta tag.
export const DEFAULT_ATTRIBUTION =
  '&copy; <a href="https://stadiamaps.com/" target="_blank" rel="noopener noreferrer">Stadia Maps</a> ' +
  '&copy; <a href="https://openmaptiles.org/" target="_blank" rel="noopener noreferrer">OpenMapTiles</a> ' +
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors';

// The attribution HTML for this page's tile layers, read from the credit the
// connect layout emits (<meta name="connect-map-attribution">, ultimately
// Connect.map_tile_attribution / CONNECT_MAP_TILE_ATTRIBUTION).
//
// It comes from the LAYOUT rather than from template-authored island props or
// data attributes on purpose: Leaflet renders attribution with innerHTML, and
// island props are substituted back into the page after the custom-template
// sanitizer runs — so a prop would let an untrusted template author inject HTML.
// <meta> is not in that sanitizer's tag allowlist, so a custom template cannot
// forge this one.
//
// With nothing emitted we fall back to DEFAULT_ATTRIBUTION rather than to an
// empty control: an unattributed map is a licence breach, and this is the last
// line of defence for a render path that forgot the meta tag.
export function tileAttribution() {
  const configured = document
    .querySelector('meta[name="connect-map-attribution"]')
    ?.getAttribute("content")
    ?.trim();
  return configured || DEFAULT_ATTRIBUTION;
}

// Drop Leaflet's own prefix while leaving the attribution control in place.
export function removeLeafletPrefix(map) {
  map?.attributionControl?.setPrefix(false);
}
